import { Campaign, OrderDetails, OrderSummary } from '@tff/types/TFF';
import * as TFF from '@tff/types/TFF';
import { filterActiveFee } from '../routes/settings/FeeConfigs/filter-active-fee';

export const fetchServiceFeeFromCampaign = (
  action: string,
  orderDetails: OrderDetails,
  orderSummary: OrderSummary,
  campaigns: Campaign[],
  bookingSource: TFF.TffBookingSource,
) => {
  const outboundFirstSegment = orderDetails.Journeys[0].Segments[0];
  const travelDate = outboundFirstSegment.DepartureTime;

  let bookingDate = orderSummary?.BookingDate;

  if (bookingDate?.at(-1) === '*') {
    bookingDate = bookingDate.slice(0, -1);
  }

  const serviceFeeFromCampaign: TFF.Fee = filterActiveFee(campaigns, {
    bookingSource: bookingSource,
    action: action,
    channel: 'CALLCENTER',
    travelDate: new Date(travelDate),
    bookingDate: new Date(bookingDate),
    currency: orderSummary?.Currency,
  });

  return serviceFeeFromCampaign;
};
